<template>
  <div class="host vm-form-group">
    <div v-if="scheme.name" class="vm-form-group-header">
      <h4>{{ scheme.name }}</h4>
    </div>
    <div class="vm-form-group-fields">
      <div class="vm-form-group-field" v-for="(item, name) in data" :key="name">
        <FormArray
          v-if="Array.isArray(scheme.controls[name].controls)"
          @add="$emit('add', $event)"
          @remove="$emit('remove', $event)"
          :scheme="scheme.controls[name]"
          :options="options"
          :data="item"
        />
        <FormGroup
          v-else-if="typeof scheme.controls[name].controls !== 'undefined'"
          @add="$emit('add', $event)"
          @remove="$emit('remove', $event)"
          :scheme="scheme.controls[name]"
          :options="options"
          :data="item"
        />
        <FormControl
          v-else
          :control="scheme.controls[name]"
          :options="options"
          :data="item"
          @select="$emit('select', $event)"
        />
      </div>
    </div>
    <div class="vm-bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
import FormControl from './FormControl';

export default {
  name: 'FormGroup',
  components: {
    FormArray: () => import('./FormArray'),
    FormControl
  },
  props: {
    scheme: Object,
    options: Object,
    data: Object
  }
};
</script>
<style scoped>
.vm-form-group {
  width: 100%;
  border: 1px solid #dfdfdf;
  border-radius: 6px;
  margin-bottom: 1rem;
}
.vm-form-group:last-child {
  margin-bottom: 0;
}
.vm-form-group-header {
  border-bottom: 1px solid #dfdfdf;
  padding: 1rem 2rem 1rem 2rem;
}
.vm-form-group-header h4 {
  margin-bottom: 0;
  font-size: 1rem;
  text-transform: uppercase;
}
.vm-form-group-fields {
  padding: 2rem 2rem 1rem 2rem;
}
.vm-form-group-field {
  margin-bottom: 1rem;
}
.vm-form-group-field:last-child {
  margin-bottom: 0;
}
.vm-bottom {
  padding: 0 2rem 1rem 2rem;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 600px) {
  .vm-form-group,
  .vm-form-group-field {
    margin-bottom: 0.5rem;
  }
  .vm-form-group-header {
    padding: 0.5rem 1rem 0.5rem 1rem;
  }
  .vm-form-group-fields {
    padding: 1rem 1rem 0.5rem 1rem;
  }
  .vm-bottom {
    padding: 0 1rem 0.5rem 1rem;
  }
}
</style>
